import type { NuxtUiTheme } from '../types/nuxt-ui-theme';
import {
    controlDescriptionStyles,
    controlLabelStyles,
    checkableControlDisabledStyles,
    checkableControlRootStateStyles
} from '../shared-styles';

export default {
    variants: {
        variant: {
            neumorphic: {
                root:
                    'relative flex items-center cursor-pointer font-(family-name:--primary-font) pt-2 ' +
                    checkableControlRootStateStyles,
                container: 'pl-[1.15rem] flex items-center shrink-0',
                base:
                    'relative flex items-center justify-center overflow-hidden! cursor-pointer appearance-none! ' +
                    'w-5.5! h-5.5! rounded-[0.4375rem]! shrink-0 border-[0.063rem]! border-solid! ' +
                    'border-(--control-border-neumorphic)! bg-(image:--control-bg-neumorphic)! ' +
                    'shadow-(--input-neumorphic-base-shadow)! [box-shadow:var(--input-neumorphic-base-shadow)]! ' +
                    'ring-0! ring-transparent! focus:ring-0! focus-visible:ring-0! outline-none! focus:outline-none! ' +
                    'focus-visible:outline-none! [outline:none]! ' +
                    '[transition:border-color_0.3s_cubic-bezier(0.25,0.8,0.25,1),box-shadow_0.3s_cubic-bezier(0.25,0.8,0.25,1),background_0.3s_cubic-bezier(0.25,0.8,0.25,1)] ' +
                    'will-change-[border-color,box-shadow,background] ' +
                    'hover:border-(--control-border-neumorphic-hover)! ' +
                    'hover:bg-(image:--control-bg-neumorphic-hover)! hover:shadow-(--input-neumorphic-hover-shadow)! ' +
                    'focus-visible:border-(--input-neumorphic-focus-border)! ' +
                    'focus-visible:shadow-(--input-neumorphic-focus-shadow)! ' +
                    'data-[state=checked]:bg-(image:--button-dark-surface)! ' +
                    'data-[state=checked]:border-(--input-neumorphic-checked-border)! ' +
                    'data-[state=checked]:shadow-(--input-neumorphic-checked-shadow)! ' +
                    'data-[state=checked]:hover:shadow-(--input-neumorphic-checked-hover-shadow)! ' +
                    'data-[state=indeterminate]:bg-(image:--button-dark-surface)! ' +
                    'data-[state=indeterminate]:border-(--input-neumorphic-checked-border)! ' +
                    'data-[state=indeterminate]:shadow-(--input-neumorphic-checked-shadow)! ' +
                    'data-[state=indeterminate]:hover:shadow-(--input-neumorphic-checked-hover-shadow)! ' +
                    checkableControlDisabledStyles,
                indicator:
                    'flex items-center justify-center w-full h-full bg-transparent! animate-neumorphic-checkbox-pop',
                icon: 'size-3! shrink-0 text-(--white-alpha-92) drop-shadow-[0_0.0625rem_0.125rem_rgba(0,0,0,0.25)]',
                wrapper: 'flex flex-col ml-3',
                label: controlLabelStyles,
                description: controlDescriptionStyles
            }
        }
    }
} satisfies NuxtUiTheme['checkbox'];
